import { render } from "./SoldVsBackorders.vue?vue&type=template&id=c259fb68"
import script from "./SoldVsBackorders.vue?vue&type=script&lang=js"
export * from "./SoldVsBackorders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__